module.exports = __webpack_public_path__ + "img/IconoEKbanner.64de05c7.png";